module.exports = __webpack_public_path__ + "img/Document Data-Active.a7cd0f03.svg";